<template>
    <b-modal v-model="show" size="lg" title="КАТТА КИЧИКЛИГИГА ТУЗАТИШ ТУРИ" class="cadastre-building">
        <div class="container-fluid content-wrap">
            <div class="row">
                <div class="col-12">
                    <div class="form-group">
                        <label>Код <span class="red">*</span></label>
                        <input
                                type="text"
                                class="form-control"
                                v-model="data.code"
                                :class="{'is-invalid': $v.data.code.$error}"
                                @blur="$v.data.code.$touch()"
                        />
                        <div class="invalid-feedback" v-if="$v.data.code.$error">{{$t("realEstate.validation.cadastreBuildingFieldEdit.code")}}</div>
                    </div>
                    <div class="form-group">
                        <label>Текст <span class="red">*</span></label>
                        <input
                                type="text"
                                class="form-control"
                                v-model="data.name"
                                :class="{'is-invalid': $v.data.name.$error}"
                                @blur="$v.data.name.$touch()"
                        />
                        <div class="invalid-feedback" v-if="$v.data.name.$error">{{$t("realEstate.validation.cadastreBuildingFieldEdit.nameUz")}}</div>
                    </div>
                    <div class="form-group">
                        <label>Текст(ru) <span class="red">*</span></label>
                        <input
                                type="text"
                                class="form-control"
                                v-model="data.nameRu"
                                :class="{'is-invalid': $v.data.nameRu.$error}"
                                @blur="$v.data.nameRu.$touch()"
                        />
                        <div class="invalid-feedback" v-if="$v.data.nameRu.$error">{{$t("realEstate.validation.cadastreBuildingFieldEdit.nameRu")}}</div>
                    </div>
                    <template v-for="(field, index) in cadastreBuildingFields">
                        <div class="form-group" v-if="field.code === 'sq_category'" :key="field.code">
                            <label>{{field.name}} <span class="red" v-if="field.required">*</span></label>
                            <select class="form-control" v-model="field.value"
                                    :class="{invalid : $v.cadastreBuildingFields.$each[index].value.$error}" @change="onFieldValueChange(field)">
                                <option :value="option.id" v-for="option in cadastreBuildingFieldReferences[field.reference.code]" :key="option.id">{{option.name}}</option>
                            </select>
                            <div class="red" v-if="$v.cadastreBuildingFields.$each[index].value.$error">{{$t("building.validation.customFieldSelect", [field.name.toLowerCase()])}}</div>
                        </div>
                    </template>
                    <div class="form-group">
                        <label>Бино тури <span class="red">*</span></label>
                        <v-select v-model="data.buildingFix" label="name"
                                  :options="cadastreBuildingFixSizes"
                                  :filterable="false"
                                  @search="onBuildingFixSizeSearch"
                                  @change="onBuildingFixSizeChange"
                        >
                            <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                        </v-select>
                    </div>
                </div>
                <div class="col-12 col-lg-6">
                    <div class="form-group">
                        <label>Кадастр раками <span class="red">*</span></label>
                        <cadastre-input :cadastre-number.sync="data.cadastreDocNumber" :invalid="$v.data.cadastreDocNumber.$error"/>
                    </div>
                    <div class="form-group" v-if="!isCategoryMultiStorey">
                        <div class="form-check checkbox-inline" style="margin-left:-30px">
                            <label class="form-check-label">
                                <input class="form-check-input" type="checkbox"
                                       v-model="data.separateBuilding">
                                <span class="form-check-sign"></span>
                                Алоҳида қурилган бино
                            </label>
                        </div>
                    </div>
                    <div class="form-group">
                        <label>{{$t("building.field.floors")}} <span class="red">*</span></label>
                        <select class="form-control"
                                v-model="data.storey"
                        >
                            <option :value="option.value"
                                    v-for="option in ref.storeys"
                                    :key="option.label">{{option.label}}
                            </option>
                        </select>
                    </div>
                    <div class="form-group" v-if="!data.separateBuilding">
                        <label>Қавати <span class="red">*</span></label>
                        <select class="form-control"
                                v-model="data.floor">
                            <option :value="option.value"
                                    v-for="option in ref.floors"
                                    :key="option.label">{{option.label}}
                            </option>
                        </select>
                    </div>
                    <template v-for="(field, index) in cadastreBuildingFields">
                        <div class="form-group" :key="field.code" v-if="isLeftCustomField(field)">
                            <label>{{field.name}} <span class="red" v-if="field.required">*</span></label>
                            <template v-if="field.type === 'TEXT'">
                                <input type="text" class="form-control" v-model="field.value"
                                       :class="{invalid : $v.cadastreBuildingFields.$each[index].value.$error}" @change="onFieldValueChange(field)"/>
                                <div class="red" v-if="$v.cadastreBuildingFields.$each[index].value.$error">{{$t("building.validation.customField", [field.name.toLowerCase()])}}</div>
                            </template>
                            <template v-else-if="field.type === 'INTEGER'">
                                <numeric-input v-model="field.value"
                                               :class="{invalid : $v.cadastreBuildingFields.$each[index].value.$error}" @change="onFieldValueChange(field)"></numeric-input>
                                <div class="red" v-if="$v.cadastreBuildingFields.$each[index].value.$error">{{$t("building.validation.customField", [field.name.toLowerCase()])}}</div>
                            </template>
                            <template v-else-if="field.type === 'DECIMAL'">
                                <numeric-input v-model="field.value" :precision="3"
                                               :class="{invalid : $v.cadastreBuildingFields.$each[index].value.$error}" @change="onFieldValueChange(field)"></numeric-input>
                                <div class="red" v-if="$v.cadastreBuildingFields.$each[index].value.$error">{{$t("building.validation.customField", [field.name.toLowerCase()])}}</div>
                            </template>
                            <template v-else-if="field.type === 'LISTBOX'">
                                <select class="form-control" v-model="field.value"
                                        :class="{invalid : $v.cadastreBuildingFields.$each[index].value.$error}" @change="onFieldValueChange(field)">
                                    <option :value="option.id" v-for="option in cadastreBuildingFieldReferences[field.reference.code]" :key="option.id">{{option.name}}</option>
                                </select>
                                <div class="red" v-if="$v.cadastreBuildingFields.$each[index].value.$error">{{$t("building.validation.customFieldSelect", [field.name.toLowerCase()])}}</div>
                            </template>
                            <template v-else-if="field.type === 'COMBOBOX'">
                                <v-select v-model="field.selected" label="name"
                                          :options="cadastreBuildingFieldReferences[field.reference.code]"
                                          :filterable="false"
                                          :class="{invalid : $v.cadastreBuildingFields.$each[index].value.$error}" @change="onFieldValueChange(field)">
                                    <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                                </v-select>
                                <div class="red" v-if="$v.cadastreBuildingFields.$each[index].value.$error">{{$t("building.validation.customFieldSelect", [field.name.toLowerCase()])}}</div>
                            </template>
                            <template v-else-if="field.type === 'MULTISELECT'">
                                <treeselect class="form-control" v-model="field.selected" :multiple="true"
                                            placeholder="Танланг..."
                                            :options="multiSelectOptions(cadastreBuildingFieldReferences[field.reference.code])"
                                            :class="{invalid : $v.cadastreBuildingFields.$each[index].value.$error}" @input="onFieldValueChange(field)"></treeselect>
                                <div class="red" v-if="$v.cadastreBuildingFields.$each[index].value.$error">{{$t("building.validation.customFieldSelect", [field.name.toLowerCase()])}}</div>
                            </template>
                            <template v-else-if="field.type === 'DATE_PICKER'">
                                <datepicker class="form-control" format="dd/MM/yyyy" v-model="field.date" :clear-button="true"
                                            :class="{invalid : $v.cadastreBuildingFields.$each[index].date.$error}" @change="onFieldValueChange(field)"></datepicker>
                                <div class="red" v-if="$v.cadastreBuildingFields.$each[index].value.$error">{{$t("building.validation.customFieldSelect", [field.name.toLowerCase()])}}</div>
                            </template>
                        </div>
                    </template>
                </div>
                <div class="col-12 col-lg-6">
                    <template v-for="(field, index) in cadastreBuildingFields">
                        <div class="form-group" :key="field.code" v-if="isRightCustomField(field)">
                            <label>{{field.name}} <span class="red" v-if="field.required">*</span></label>
                            <template v-if="field.type === 'TEXT'">
                                <input type="text" class="form-control" v-model="field.value"
                                       :class="{invalid : $v.cadastreBuildingFields.$each[index].value.$error}" @change="onFieldValueChange(field)"/>
                                <div class="red" v-if="$v.cadastreBuildingFields.$each[index].value.$error">{{$t("building.validation.customField", [field.name.toLowerCase()])}}</div>
                            </template>
                            <template v-else-if="field.type === 'INTEGER'">
                                <numeric-input v-model="field.value"
                                               :class="{invalid : $v.cadastreBuildingFields.$each[index].value.$error}" @change="onFieldValueChange(field)"></numeric-input>
                                <div class="red" v-if="$v.cadastreBuildingFields.$each[index].value.$error">{{$t("building.validation.customField", [field.name.toLowerCase()])}}</div>
                            </template>
                            <template v-else-if="field.type === 'DECIMAL'">
                                <numeric-input v-model="field.value" :precision="3"
                                               :class="{invalid : $v.cadastreBuildingFields.$each[index].value.$error}" @change="onFieldValueChange(field)"></numeric-input>
                                <div class="red" v-if="$v.cadastreBuildingFields.$each[index].value.$error">{{$t("building.validation.customField", [field.name.toLowerCase()])}}</div>
                            </template>
                            <template v-else-if="field.type === 'LISTBOX'">
                                <select class="form-control" v-model="field.value"
                                        :class="{invalid : $v.cadastreBuildingFields.$each[index].value.$error}" @change="onFieldValueChange(field)">
                                    <option :value="option.id" v-for="option in cadastreBuildingFieldReferences[field.reference.code]" :key="option.id">{{option.name}}</option>
                                </select>
                                <div class="red" v-if="$v.cadastreBuildingFields.$each[index].value.$error">{{$t("building.validation.customFieldSelect", [field.name.toLowerCase()])}}</div>
                            </template>
                            <template v-else-if="field.type === 'COMBOBOX'">
                                <v-select v-model="field.selected" label="name"
                                          :options="cadastreBuildingFieldReferences[field.reference.code]"
                                          :filterable="false"
                                          :class="{invalid : $v.cadastreBuildingFields.$each[index].value.$error}" @change="onFieldValueChange(field)">
                                    <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                                </v-select>
                                <div class="red" v-if="$v.cadastreBuildingFields.$each[index].value.$error">{{$t("building.validation.customFieldSelect", [field.name.toLowerCase()])}}</div>
                            </template>
                            <template v-else-if="field.type === 'MULTISELECT'">
                                <treeselect class="form-control" v-model="field.selected" :multiple="true"
                                            placeholder="Танланг..."
                                            :options="multiSelectOptions(cadastreBuildingFieldReferences[field.reference.code])"
                                            :class="{invalid : $v.cadastreBuildingFields.$each[index].value.$error}" @input="onFieldValueChange(field)"></treeselect>
                                <div class="red" v-if="$v.cadastreBuildingFields.$each[index].value.$error">{{$t("building.validation.customFieldSelect", [field.name.toLowerCase()])}}</div>
                            </template>
                            <template v-else-if="field.type === 'DATE_PICKER'">
                                <datepicker class="form-control" format="dd/MM/yyyy" v-model="field.date" :clear-button="true"
                                            :class="{invalid : $v.cadastreBuildingFields.$each[index].date.$error}" @change="onFieldValueChange(field)"></datepicker>
                                <div class="red" v-if="$v.cadastreBuildingFields.$each[index].value.$error">{{$t("building.validation.customFieldSelect", [field.name.toLowerCase()])}}</div>
                            </template>
                        </div>
                    </template>
                </div>
            </div>
        </div>
        <div slot="modal-footer" class="w-100 pt-3" style="border-top: 1px solid #CCCCCC">
            <button class="all-btn add-btn float-right" v-if="hasPermission('SETTINGS_BUILDING_CADASTRE_FIX_SIZE_TYPE_ADD')" @click="save" :disabled="processing">
                {{$t('action.save')}}
            </button>
            <button class="all-btn delete-btn float-right mr-2" @click="show=!show">
                {{$t('action.cancel')}}
            </button>
        </div>
    </b-modal>
</template>

<script>
    import bModal from 'bootstrap-vue/es/components/modal/modal';
    import bModalDirective from 'bootstrap-vue/es/directives/modal/modal';
    import initFilterModel from '@/shared/filter';
    import { required, requiredUnless } from 'vuelidate/lib/validators';
    import Treeselect from '@riophae/vue-treeselect';
    import {TheMask} from 'vue-the-mask';
    import COMPARISON_REFERENCES from '@/shared/constants/realEstateComparison';
    import CadastreInput from "@/components/CadastreInput.vue";
    import {cadastreNumber} from "@/shared/validator-helpers";

    export default {
        name: "CadastreFixSizeEditModal",
        components: {
          CadastreInput,
            'b-modal': bModal,
            Treeselect,
            TheMask
        },
        directives: {
            'b-modal': bModalDirective
        },
        data() {
            return {
                show: false,
                processing: false,
                buildingFixSizeFilter: initFilterModel(),
                data: this.initEmptyData(),
                cadastreBuildingFixSizes: [],
                cadastreBuildingFields: [],
                cadastreBuildingFieldReferences: {},
                fields: [],
                ref: {
                    ...COMPARISON_REFERENCES
                }
            }
        },
        validations() {
            return {
                data: {
                    code:{
                        required
                    },
                    name:{
                        required
                    },
                    nameRu: {
                        required
                    },
                    cadastreDocNumber: {
                        required,
                        cadastreNumber: cadastreNumber
                    }
                },
                cadastreBuildingFields: {
                    $each: {
                        value: {
                            required: requiredUnless(vm => {
                                return !(!vm.system && this.hasField(vm.code) && vm.required);
                            })
                        }
                    }
                }
            }
        },
        computed: {
            isCategoryMultiStorey() {
                let buildingFix = this.data.buildingFix;
                return buildingFix && buildingFix.buildingType && buildingFix.buildingType.code === "RESIDENTIAL_MULTI_STOREY";
            }
        },
        methods: {
            initEmptyData() {
                return {
                    code: '',
                    name: '',
                    nameRu: '',
                    buildingFix: null,
                    cadastreDocNumber: '',
                    storey: 1,
                    floor: 1,
                    separateBuilding: false,
                    data: {
                        values: {}
                    }
                }
            },
            init(data) {
                const vm = this;
                if (data) {
                    vm.initResponse(data);
                    vm.initData(data);
                } else {
                    this.data = this.initEmptyData();
                    this.$http.get('/cadastre/fix-size-type/init')
                        .then(res => {
                            vm.initResponse(res.data);
                        }, err => {
                            console.log(err);
                        });
                }
            },
            initResponse(data) {
                this.cadastreBuildingFieldReferences = data.references;
                this.cadastreBuildingFields = data.fields;
                this.cadastreBuildingFixSizes = data.fixSizes;
            },
            initData(data) {
                let formData = data
                const vm = this;
                if (formData && formData.data.values) {
                    vm.cadastreBuildingFields.forEach((field) => {
                        if (field.code && !field.system && formData.data.values.hasOwnProperty(field.code)) {
                            const fieldValue = formData.data.values[field.code];
                            if (fieldValue) {
                                if (field.type === 'COMBOBOX' || field.type === 'LISTBOX') {
                                    if (fieldValue.id && fieldValue.id > 0) {
                                        field.value = fieldValue.id;
                                        field.selected = vm.getReferenceById(field.reference.code, fieldValue.id);
                                    }
                                } else if (field.type === 'MULTISELECT') {
                                    if (fieldValue) {
                                        field.selected = [];
                                        if (fieldValue.length > 0) {
                                            fieldValue.forEach((ref) => {
                                                field.selected.push(ref.id);
                                            });
                                        } else if (fieldValue.hasOwnProperty('id') && fieldValue.id && fieldValue.id > 0) {
                                            field.selected.push(fieldValue.id);
                                        }
                                        field.value = field.selected;
                                    }
                                } else {
                                    field.value = fieldValue;
                                }
                            }
                        }
                    })
                }
                if (!formData) {
                    formData = vm.initEmptyData()
                }

                vm.data = formData
            },
            save() {
                this.$v.$touch()
                if (this.$v.$invalid) {
                    return;
                }
                const vm = this;
                this.processing = true

                this.$http.post('cadastre/fix-size-type', this.data)
                    .then(res => {
                        vm.processing = false
                        let response = res.data;
                        if (response && response.status === "SUCCESS") {
                            vm.show = false
                            this.$eventBus.$emit('onCadastreFixSizeTypeChanged', response);
                        }
                    }, err => {
                        console.log(err)
                        vm.processing = false
                    })
            },
            getReferenceById(code, id) {
                if (this.cadastreBuildingFieldReferences.hasOwnProperty(code)) {
                    const fieldReferences = this.cadastreBuildingFieldReferences[code];
                    const references = fieldReferences.filter((ref) => {
                        return ref.id === id
                    });
                    return references.length > 0 ? references[0] : null;
                } else {
                    return null;
                }
            },
            onFieldValueChange(field) {
                if (!field.system) {
                    let fieldValue = {};
                    if (field.type === 'COMBOBOX' || field.type === 'LISTBOX') {
                        if (field.type === 'LISTBOX') {
                            field.selected = this.getReferenceById(field.reference.code, field.value);
                        }
                        if (field.selected) {
                            fieldValue = {
                                id: field.selected.id,
                                code: field.selected.code
                            }
                        }
                        if (field.type === 'COMBOBOX') {
                            field.value = fieldValue;
                        }
                    } else if (field.type === 'MULTISELECT') {
                        fieldValue = [];
                        if (field.selected && field.selected.length > 0) {
                            field.selected.forEach((ref_id) => {
                                const ref = this.getReferenceById(field.reference.code, ref_id);
                                if (ref) {
                                    fieldValue.push({
                                        id: ref.id,
                                        code: ref.code
                                    })
                                }
                            });
                        }
                        field.value = fieldValue;
                    } else {
                        fieldValue = field.value;
                    }
                    this.data.data.values[field.code] = fieldValue;
                }
            },
            onBuildingFixSizeSearch(searchTxt, loading) {
                loading(true);
                this.cadastreBuildingFixSizes = [];
                this.buildingFixSizeFilter.search = searchTxt;
                this.$http.post('cadastre/building/fix-by-size/list', this.buildingFixSizeFilter)
                    .then(res => {
                        this.cadastreBuildingFixSizes = res.data.data;
                        loading(false);
                    }, err => {
                        console.log(err);
                    });
            },
            onBuildingFixSizeChange(value) {
                this.fields = [];
                if (value) {
                    this.fields = value.data.fields
                }
            },
            isLeftCustomField(field) {
                return !field.system && field.alignment === 1 && this.hasField(field.code);
            },
            isRightCustomField(field) {
                return !field.system && field.alignment === 2 && this.hasField(field.code);
            },
            hasField(code) {
                return this.fields.includes(code);
            },
            multiSelectOptions(options) {
                const items = [];
                if (options && options.length > 0) {
                    options.forEach((option) => {
                        items.push({
                            id: option.id,
                            label: option.name
                        });
                    });
                }
                return items;
            }
        },
        created() {
            this.$eventBus.$on('showCadastreFixSizeTypeEditModal', (data) => {
                this.init(data)
                this.show = true
            })
        }
    }
</script>

<style scoped>
    .content-wrap {
        min-height: 500px;
        max-height: 700px;
        overflow-y: auto;
        overflow-x: auto;
    }
</style>